import { render, staticRenderFns } from "./Tutors.vue?vue&type=template&id=62cc843f&scoped=true&"
import script from "./Tutors.vue?vue&type=script&lang=js&"
export * from "./Tutors.vue?vue&type=script&lang=js&"
import style0 from "./Tutors.scss?vue&type=style&index=0&id=62cc843f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cc843f",
  null
  
)

export default component.exports